import Lights from 'shared/components/lights';
import { ActiveLanguage, isEmbedVideo } from 'shared/vidio_helpers';

const requireLoginModal = require('templates/modals/require_login_modal.jst.jade')

export default class RequireLoginModal {

  constructor({ element: element }) {
    this.element = element;
    this.html = null;
    this.body = $('body');
    this.lights = Lights;
    this.ui = {
      root: '.popup',
      icon: '.popup__icon',
      close: '.popup__close',
      content: '.popup__content'
    };

    const lang = ActiveLanguage.get();
    this.locale = window.Locale[lang].modal 
  }

  init() {
    $(this.element).click(this.onClick.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.lights.off.bind(this)();
    this.render();
    this.body.append(this.html);
    this.onClose();
    this._disableBodyOverflow();
    window.scrollTo(0,0);
  }

  onClose() {
    this.html.find(this.ui.close).on('click', function() {
      this.close();
    }.bind(this));
  }

  _disableBodyOverflow() {
    document.getElementsByTagName("body")[0].style.overflow = 'hidden';
  }

  _enableBodyOverflow() {
    document.getElementsByTagName("body")[0].style.overflow = 'auto';
  }

  render() {
    const data = {
      title: $(this.element).data('title') || $(this.element).attr('title'),
      url: this.getUrl(),
      locale: this.locale,
      embed: isEmbedVideo()
    };
    const content = $(requireLoginModal(data));
    this.html = content;
    if (window.player && window.player.tech() && window.player.tech().plugin()) {
      window.player.tech().pause();
    }
  }

  close() {
    $(this.ui.root).remove();
    this.lights.on();
    this._enableBodyOverflow();
  }

  getUrl(){
    var url = $(this.element).data('url');

    if(isEmbedVideo()){
      var parsedUrl = new URL(url)
      parsedUrl.searchParams.set("user_return_to", document.referrer);
      url = parsedUrl.href;
    }
    return url;
  }
}
